import { render, staticRenderFns } from "./EditTransferStoreForm.vue?vue&type=template&id=1ef2fafa"
import script from "./EditTransferStoreForm.vue?vue&type=script&lang=js"
export * from "./EditTransferStoreForm.vue?vue&type=script&lang=js"
import style0 from "./EditTransferStoreForm.vue?vue&type=style&index=0&id=1ef2fafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports